import Api from '.';

class DbApi extends Api {
  base_endpoint = 'dbs';

  getDatasets(id, params) {
    return this.doRequest('get', `${id}/datasets`, { params });
  }

  getDatasetsByDbName(db_name, params) {
    params.db_name = db_name;
    return this.doRequest('get', `datasets`, { params });
  }

  importData(data, params) {
    return this.upload(`import-data`, data, params);
  }

  getTemplate(id, params) {
    return this.doRequest('get', `${id}/template`, { params });
  }

  getDatasetsByPage(dbId, params) {
    return this.doRequest('get', `${dbId}/datasets`, { params });
  }
}

export default new DbApi();
